// 업데이트 게시글 URL(/update/:id-:slug)에 제목 키워드를 넣기 위한 슬러그 생성기.
// 숫자 ID만 있는 URL(/update/1)은 검색엔진/사용자 둘 다에게 의미가 없어서
// 제목을 그대로 URL에 노출시킨다("주소가 최적화 맞아?" 지적, 2026-08-28).
// 한글은 로마자로 안 바꾸고 그대로 둔다 - 네이버/구글 둘 다 한글 URL을 그대로
// 색인하고, 오히려 한국어 검색 의도에는 이게 더 유리하다.
export function slugify(title) {
    return String(title || '')
        .replace(/<[^>]*>/g, '')
        .trim()
        .toLowerCase()
        .replace(/[^\p{L}\p{N}\s-]/gu, '')
        .replace(/\s+/g, '-')
        .slice(0, 50)
        .replace(/-+$/, '');
}

export function buildUpdateUrl(item) {
    const slug = slugify(item?.title);
    return slug ? `/update/${item.id}-${slug}` : `/update/${item.id}`;
}
